import "./styles.css"
import { ReactComponent as PlusIcon } from "../../../assets/svg/icons/plus.svg";
import { useEditOnboarding } from "../../../hooks/useEditOnboarding";
import TableVisualizationRow from "./TableVisualizationRow/Index";
import { Loading } from "../../Loading/Index";

interface TablePastureManagementProps {
  listTable: IMicroAreaManagementContent[];
  isLoading: boolean;
  isHistory: boolean;
}

export default function TablePastureManagement({ listTable, isLoading, isHistory }: TablePastureManagementProps) {

  const {
    setOptionForm,
  } = useEditOnboarding();

  return (
    <>
      {listTable && listTable.length > 0 ?
        <>
          <table className="tableTaskEvaluation" style={{ minWidth: 1280 }} id="tablePastureManagement">
            <thead>
              <tr>
                <th>Sigla</th>
                <th>Fazenda</th>
                <th>Retiro</th>
                <th>Pastos</th>
                <th>Tipo de Pastejo</th>
                <th>Frequência</th>
                <th>Data<br/>Inicio</th>
                {isHistory && <th>Data<br/>Final</th>}
                <th />
              </tr>
            </thead>

            <tbody>
              {listTable.map(management =>
                <TableVisualizationRow microAreaManagement={management} isHistory={isHistory} />
              )}
            </tbody>
          </table>

          {isLoading && (
            <div className="tableLoadingOverlay">
              <div className="lds-ring">
                <div></div>
                <div></div>
              </div>
            </div>
          )}
        </>
        :
        isLoading
          ?
          <div className="emptyTable_container">
            <Loading visible={true} />
          </div>
          :
          <div className="emptyTable_container">
            <span> Nenhum resultado encontrado.</span>
          </div>
      }
    </>
  )
}